<template>
    <div :v-loading="loading.actions['booking']">
        <el-card
                shadow="never"
                style="margin: 2px 0;"
        >
            <el-form
                    :model="filter"
                    :rules="rules"
                    label-width="120px"
                    ref="form"
            >
                <el-form-item label="日期" prop="date">
                    <el-date-picker
                            :clearable="false"
                            :editable="false"
                            :picker-options="options"
                            placeholder="請選擇要查詢的日期"
                            type="date"
                            v-model="filter.date"
                            value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="節次起訖" prop="periods">
                    <period-picker
                            :comparer="(b, e) => e >= b"
                            :options="periodOpt"
                            v-model="filter.periods"
                    ></period-picker>
                </el-form-item>
                <el-button
                        :loading="loading.actions['booking']"
                        @click="query"
                        icon="el-icon-search"
                        size="medium"
                        type="info"
                >
                    查詢
                </el-button>
                <el-button
                        @click="reset"
                        icon="el-icon-refresh-left"
                        size="medium"
                >
                    重設
                </el-button>
            </el-form>
        </el-card>
        <el-divider>查詢結果</el-divider>
        <el-card
                shadow="never"
                style="margin: 2px 0; height: 400px"
        >
            <div v-if="vacancyRooms.length > 0">
                ※請點擊欲借用的教室
            </div>
            <div style="max-height: 300px; overflow-y: auto; ">
                <el-button
                        :key="r.id"
                        @click="prompt(r)"
                        style="margin-bottom: 5px;"
                        v-for="r in vacancyRooms"
                >
                    {{r.name}}{{r.isHidden ? '（已隱藏）' : ''}}
                </el-button>
            </div>
        </el-card>
        <el-dialog
                :visible.sync="show"
                center
                title="請選擇你要的動作"
                width="30%"
        >
            <el-button @click="immediatelyBook">直接借用此時段</el-button>
            <el-button @click="toBook">至借用登記</el-button>
            <div style="margin-top: 5px;">
                <el-input
                        type="textarea"
                        v-model="reason"
                        placeholder="請輸入事由(選填)"
                ></el-input>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import PeriodPicker from '../PeriodPicker';
import moment from 'moment';
import {TotalPeriods} from '@/constants';

const defaultFilter = {
        date: moment().format('YYYY-MM-DD'),
        periods: [],
    };
    export default {
        name: 'AdminVacancyRoomQuery',
        components: {
            PeriodPicker
        },
        data: () => ({
            show: false,
            selectedRoomId: '',
            vacancyRooms: [],
            filter: {...defaultFilter},
            reason:'',
            rules: {
                date: [
                    {required: true, message: '請輸入要查詢的日期', trigger: 'blur'},
                ],
                periods: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value || value.length < 2 || value.some(v => !v)) {
                                callback(new Error('請選擇節次起訖'));
                            }
                            callback();
                        }
                    }
                ]
            },
            options: {
                disabledDate(date) {
                    return moment().isAfter(date, 'd');
                },
                firstDayOfWeek: 1
            }
        }),
        computed: {
            ...mapState(['loading']),
            ...mapState('setting', ['rooms']),
            ...mapGetters('setting', ['schoolYear', 'semester']),
            ...mapState('auth', {
                userId: state => state.userId,
            }),
            periodOpt() {
                return [...new Array(TotalPeriods).keys()].map(k => ({value: k + 1, key: k + 1, label: `第${k + 1}節`}));
            },
            selectedRoom() {
                return this.rooms.find(r => r.id === this.selectedRoomId);
            },
        },
        methods: {
            ...mapActions('booking', {
                getVacancyClassrooms: 'getVacancyClassroomsAction'
            }),
            ...mapActions('booking', {
                book: 'adminSubmitAction',
            }),
            ...mapMutations('manage', ['toBookingPage']),

            reset() {
                this.filter = {...defaultFilter};
                this.vacancyRooms.splice(0);
                this.show = false;
                this.selectedRoomId = '';
                if(this.$refs.form){
                    this.$refs.form.clearValidate();
                }
            },
            async query() {
                const {form} = this.$refs;

                await form.validate(async (valid) => {
                    if (valid) {
                        const {periods, date} = this.filter;
                        const {schoolYear, semester} = this;
                        const [begin, end] = periods;
                        const rooms = await this.getVacancyClassrooms({
                            schoolYear, semester, date,
                            begin, end
                        });
                        this.vacancyRooms.splice(0);
                        this.vacancyRooms = [...rooms];
                    }
                });
            },

            prompt({id: roomId}) {
                this.show = true;
                this.selectedRoomId = roomId;
            },

            toBook() {
                const {periods, date} = this.filter;
                if (this.selectedRoomId) {
                    this.toBookingPage({
                        periods,
                        date,
                        roomId: this.selectedRoomId,
                        reason: this.reason
                    });
                    this.reset();
                }
            },

            async immediatelyBook(){
                const {periods, date} = this.filter;
                if(this.selectedRoom){
                    const {success, messages=[]} = await this.book({
                        schoolYear: this.schoolYear,
                        semester: this.semester,
                        roomId: this.selectedRoom.ncutRoomId,
                        userId: this.userId,
                        periods: [{
                            date, begin: periods[0], end : periods[1]
                        }],
                        reason: this.reason
                    });

                    if (success) {
                        this.$message.success('登記成功!');
                        this.reset();
                    } else {
                        this.$message.warning(messages.join(','));
                    }
                }
            }

        },

    }
</script>

<style>

</style>
